// @fileoverview : 경남-PMS > 고속성형기관리 > 고속성형기일상점검등록
import { useModal } from "@/features/modal/ModalStackManager";
import { PressDailyRegisterCreateForm } from "@/features/PMS/press/pressDailyRegister/form/createForm";
import { ActionHeader } from "@/features/standard/ActionHeader";
import { Header } from "@/features/standard/Header";
import { HeaderSubTitle } from "@/features/standard/SubTitle";
import { HeaderTitle } from "@/features/standard/Title";
import { Wrapper } from "@/features/standard/Wrapper";
import { Calendar } from "@/features/ui/calendar";
import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Button, Flex, Input, Pagination, Select } from "@mantine/core";
import { IconCalendar, IconPlus, IconSearch } from "@tabler/icons-react";
import { useState } from "react";
import DataGrid, { Column, SelectColumn } from "react-data-grid";

const PressDailyRegisterWrap = {
  Header: Header,
  HeaderTitle: HeaderTitle,
  HeaderSubTitle: HeaderSubTitle,
  ActionHeader: ActionHeader,
  ActionButton: Button,
  Wrapper: Wrapper,
  CreateForm: PressDailyRegisterCreateForm,
};

export const PressDailyRegisterPage = () => {
  const { openModal } = useModal();
  const pageSize = 10;

  const [page, setPage] = useState(1); // 좌측 테이블의 페이지 상태

  const totalRows = PressMockupData.length;
  const paginatedRows = PressMockupData.slice((page - 1) * pageSize, page * pageSize);

  const columns: readonly Column<any>[] = [
    {
      ...SelectColumn,
      width: 70,
      maxWidth: 500,
      resizable: true,
      headerCellClass: css`
        & > * {
          justify-content: flex-start;
          padding-left: 24px;
        }
      `,
      cellClass: css`
        .rdg-checkbox-label {
          padding-left: 24px;
        }
      `,
    },
    {
      key: "make",
      name: "기계 제조사",
      sortable: true,
      resizable: true,
    },
    {
      key: "name",
      name: "기계 이름",
      sortable: true,
      resizable: true,
    },
    {
      key: "type",
      name: "기계 종류",
      sortable: true,
      resizable: true,
    },
    {
      key: "createdAt",
      name: "제조 연월일",
      sortable: true,
      resizable: true,
    },
    {
      key: "makeId",
      name: "제조 번호(필수)",
      sortable: true,
      resizable: true,
    },
    {
      key: "manager",
      name: "담당자",
      sortable: true,
      resizable: true,
    },
    {
      key: "inspection",
      name: "일상점검",
      sortable: true,
      resizable: true,
    },
  ];

  return (
    <Flex gap="md" direction={"column"} p="md">
      <PressDailyRegisterWrap.Header>
        <PressDailyRegisterWrap.HeaderTitle>
          {"프레스 일상점검 등록"}
        </PressDailyRegisterWrap.HeaderTitle>
        <PressDailyRegisterWrap.HeaderSubTitle>
          {"우리 회사에서 다루는 프레스 일상점검에 대해 조회합니다."}
        </PressDailyRegisterWrap.HeaderSubTitle>
      </PressDailyRegisterWrap.Header>
      <Flex justify={"space-between"}>
        <Flex>
          <PressDailyRegisterWrap.ActionHeader>
            <PressDailyRegisterWrap.ActionButton
              leftIcon={<IconPlus />}
              onClick={() =>
                openModal(<PressDailyRegisterWrap.CreateForm />, null, "프레스 일상점검 추가", true)
              }
            >
              프레스 일상점검 추가
            </PressDailyRegisterWrap.ActionButton>
          </PressDailyRegisterWrap.ActionHeader>
        </Flex>
        <Flex gap="sm">
          <Button
            leftIcon={<IconCalendar />}
            color="indigo"
            onClick={() => {
              openModal(<Calendar dates={[null, null]} type="range" />, null, "날짜 선택");
            }}
          >
            날짜선택
          </Button>
          <Select
            w={"8rem"}
            data={[
              { label: "기계 제조사", value: "all" },
              { label: "기계이름", value: "all" },
              { label: "제조번호", value: "all" },
            ]}
          />
          <Input w={"16rem"} placeholder="검색어를 입력하세요" rightSection={<IconSearch />} />
          <Button>검색</Button>
        </Flex>
      </Flex>
      <GridWrapper>
        <DataGrid columns={columns ?? []} rows={paginatedRows ?? []} rowHeight={40} />
        <Pagination
          onChange={setPage} // 페이지 변경 핸들러
          value={page}
          total={Math.ceil(totalRows / pageSize)} // 데이터에 따라 동적 계산
          size="lg"
          radius="sm"
          position="center"
        />
      </GridWrapper>
    </Flex>
  );
};

const PressMockupData: any = [
  {
    id: 1,
    make: "삼성",
    name: "ITM013",
    type: "고속성형기",
    createdAt: "2025-06-11",
    makeId: "66513241-001",
    manager: "홍자현",
    inspection: "접수 완료",
  },
  {
    id: 2,
    make: "LG",
    name: "ITM003",
    type: "고속성형기",
    createdAt: "2025-06-11",
    makeId: "7818113-002",
    manager: "김철민",
    inspection: "점검 대기 중",
  },
  {
    id: 3,
    make: "현대",
    name: "ITM005",
    type: "고속성형기",
    createdAt: "2025-06-11",
    makeId: "88215463-003",
    manager: "이영희",
    inspection: "접수 완료",
  },
  {
    id: 4,
    make: "기아",
    name: "ITM007",
    type: "고속성형기",
    createdAt: "2025-06-14",
    makeId: "68151857-004",
    manager: "박준호",
    inspection: "점검 대기 중",
  },
  {
    id: 5,
    make: "삼성",
    name: "ITM009",
    type: "고속성형기",
    createdAt: "2025-06-15",
    makeId: "11565432-005",
    manager: "최수진",
    inspection: "접수 완료",
  },
];

const GridWrapper = styled.div`
  & *[role="grid"] {
    height: 440px;
    // --rdg-background-color: {(props) => (props.isDarkMode ? "white" : "none")};
    // --rdg-header-background-color: {(props) =>
    // props.isDarkMode ? "white" : "none"};
    // --rdg-color: {(props) => (props.isDarkMode ? "black" : "white")};
    // --rdg-row-hover-background-color: {(props) =>
    // props.isDarkMode ? "#f5f5f5" : theme?.colors?.gray?.[7]};
  }
  & *[role="columnheader"] {
    // color: #7d8fa9;
    font-size: 12px;
    font-family: Roboto;
    font-weight: 500;
    word-wrap: break-word;
    // border: none;
    box-shadow: none;
    display: flex;
    align-items: center;
  }
  & *[aria-colindex="1"] {
  }

  & *[role="row"] {
    height: 100px;
  }

  & *[role="gridcell"] {
    display: flex;
    align-items: center;
    // border-left: none;
    // border-right: none;
    box-shadow: none;

    & > * {
      justify-content: flex-start;
    }
  }
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
  gap: 1rem;
`;
